import styled from '@emotion/styled'

import media from './../../../common/MediaQueries'

const MarketNewsStyled = styled.div`
  @media ${media.maxPhone} {
    margin: 0 -1.5625rem;
  }
  @media ${media.phone} {
    padding: 0 1.5625rem;
  }
  @media ${media.tablet} {
    padding: 0;
  }
`

const MarketNewsContentStyled = styled.div`
  margin-bottom: 4rem;

  .rec-carousel-item {
    display: flex;
  }

  .rec-item-wrapper {
    flex: 1;
  }

  @media ${media.phone} {
    margin-bottom: 3.125rem;
  }
`

const MarketNewsListStyled = styled.ul`
  @media ${media.maxPhone} {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    padding-left: 1.5625rem;
    margin: 0;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  @media ${media.phone} {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -0.75rem;
  }

  @media ${media.tablet} {
    display: grid;
    grid-template-areas:
      'slide-big slide-big slide-big slide-big slide-small-1 slide-small-1 slide-small-1 slide-small-1 slide-small-1 '
      'slide-big slide-big slide-big slide-big slide-small-2 slide-small-2 slide-small-2 slide-small-2 slide-small-2'
      'slide-big slide-big slide-big  slide-big slide-small-3 slide-small-3 slide-small-3 slide-small-3 slide-small-3';
    width: calc(100% + 1.25rem);
    margin-right: -1.125rem;
    margin-left: -1.125rem;
    padding: 0;
    grid-template-rows: auto;
    grid-template-columns: repeat(9, 1fr);
  }
`

const MarketNewsListItemStyled = styled.li`
  display: flex;
  height: auto;
  max-height: 100%;

  @media ${media.maxPhone} {
    margin-right: 1.5rem;
    padding: 0.3125rem 0;

    > * {
      width: 230px;
      min-width: 230px;
    }
  }
  @media ${media.phone} {
    width: 50%;
    padding: 0.75rem;
  }

  @media ${media.tablet} {
    padding: 0;
    &:nth-of-type(1) {
      grid-area: slide-big;
      grid-column: span 4;
      grid-row: span 3;
      -ms-grid-column-span: 3;
      -ms-grid-row-span: 3;
      margin: 1.125rem !important;
      width: auto !important;
    }
    &:nth-of-type(2) {
      -ms-grid-row: 1;
      -ms-grid-column: 6;
      grid-area: slide-small-1;
      margin: 1.125rem !important;
      width: auto !important;

      @media ${media.tablet} {
        margin-bottom: 0.875rem !important;
      }
    }
    &:nth-of-type(3) {
      -ms-grid-row: 2;
      -ms-grid-column: 6;
      grid-area: slide-small-2;

      margin: 1.125rem !important;
      width: auto !important;

      @media ${media.tablet} {
        margin-top: 0.875rem !important;
        margin-bottom: 0.875rem !important;
      }
    }
    &:nth-of-type(4) {
      -ms-grid-row: 3;
      -ms-grid-column: 6;
      grid-area: slide-small-3;

      margin: 1.125rem !important;
      width: auto !important;

      @media ${media.tablet} {
        margin-top: 0.875rem !important;
      }
    }
  }
`

const MarketNewsCtaStyled = styled.div`
  display: flex;
  justify-content: center;
`

export { MarketNewsStyled, MarketNewsContentStyled, MarketNewsListStyled, MarketNewsListItemStyled, MarketNewsCtaStyled }
